export type TNativePeriodicWave = PeriodicWave;
